import { ReactNode } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import Link from '@/components/Link';

import { IMenuItem } from '@/helpers/interfaces/common.interface';

import styles from './submenu-columns.module.css';

interface SubmenuColumnProps {
  title: ReactNode,
  children: ReactNode,
  className?: string,
}

const SubmenuColumn = ({ title, children, className }: SubmenuColumnProps) => {
  return (
    <div className={classNames(styles.column, className)}>
      <div className={styles.title}>
        {title}
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

interface SubmenuColumnsProps {
  templates: IMenuItem[],
  categories: IMenuItem[],
  onClickItem?: () => void,
}

const SubmenuColumns = ({ templates, categories, onClickItem }: SubmenuColumnsProps) => {
  return (
    <div className={styles.root}>
      <SubmenuColumn
        title="ПОПУЛЯРНЫЕ"
        className={styles.columnPopular}
      >
        <div className={styles.templates}>
          {templates.map(({ name, href }) => (
            <Link className={styles.template} href={href} onClick={onClickItem} key={name}>
              <img className={styles.templateIcon} src="/icons/explorer/file_forma.svg" width={42} height={42} alt={name} />
              <span className={styles.templateContent}>
                <span className={styles.templateName}>{name}</span>
                <span className={styles.templateLink}>Смотреть</span>
              </span>
            </Link>
          ))}
        </div>
      </SubmenuColumn>
      <SubmenuColumn
        title="КАТЕГОРИИ"
      >
        <div className={styles.categories}>
          {categories.map(({ id, name, href, icon }) => (
            <Link className={styles.category} href={href} title={name} onClick={onClickItem} key={id}>
              <img className={styles.categoryIcon} src={icon} width={42} height={42} alt={name} />
              <span className={styles.categoryName}>{name}</span>
            </Link>
          ))}
          <Link className={classNames(styles.category, styles.categoryAll)} onClick={onClickItem} href="/templates">
            <span className={styles.categoryName}>
              Все категории
            </span>
            <ReactSVG src="/icons/chevron-right.svg" className={styles.categoryArrow} wrapper="span" />
          </Link>
        </div>
      </SubmenuColumn>
    </div>
  );
};

export default SubmenuColumns;
